module.exports = __webpack_public_path__ + "img/warning-icon.04d4e1c154d967a05d1de7c6b22d3e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning-icon.png
// module id = 692
// module chunks = 0